import { render, staticRenderFns } from "./RichTextReader.vue?vue&type=template&id=7df4df58&"
import script from "./RichTextReader.vue?vue&type=script&lang=js&"
export * from "./RichTextReader.vue?vue&type=script&lang=js&"
import style0 from "./RichTextReader.vue?vue&type=style&index=0&id=7df4df58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports